// extracted by mini-css-extract-plugin
module.exports = {"container":"UnknownErrorVIew_container__MuWdS","title":"UnknownErrorVIew_title__3PqGG","message":"UnknownErrorVIew_message__2fgdI","button":"UnknownErrorVIew_button__2Rj3J"};